var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export function TagId(tag) {
    if (typeof tag === 'string') {
        return tag;
    }
    return tag.id;
}
export function TagName(tag, tagInfos) {
    if (typeof tag === 'string') {
        return TagNameFromId(tag, tagInfos);
    }
    // if tag is tag info, then use the name
    if ('name' in tag && tag.name) {
        return tag.name;
    }
    if (tag.id) {
        return TagNameFromId(tag.id, tagInfos);
    }
    return undefined;
}
export function TagNameFromId(tag, tagInfos) {
    var info = tagInfos.find(function (t) { return t.id === tag; });
    if (info) {
        return info.name;
    }
    var result = tag;
    if (tag.includes(':')) {
        result = tag.split(':')[1];
    }
    var parts = result.split('_');
    for (var i = 0; i < parts.length; i++) {
        parts[i] = parts[i].charAt(0).toUpperCase() + parts[i].slice(1);
    }
    return parts.join(' ');
}
export function toggleTag(selectedTags, tag) {
    var wasSelected = selectedTags.find(function (t) { return t.id === tag.id; });
    if (wasSelected) {
        return selectedTags.filter(function (t) { return t.id !== tag.id; });
    }
    function isConflictingTag(t) {
        if (tag.group && t.group === tag.group) {
            // only one tag from the group can be selected
            return false;
        }
        return true;
    }
    var result = selectedTags.filter(function (t) { return !isConflictingTag(t); });
    result.push(tag);
    return result;
}
export function displayInList(tag, selectedTags) {
    // by default all tags are displayed
    return true;
}
export function sortTags(tags) {
    var groupedTags = tags.filter(function (t) { return t.group && t.group.length > 0; });
    var otherTags = tags.filter(function (t) { return !t.group; });
    groupedTags = groupedTags.sort(function (a, b) {
        if (a.group && b.group) {
            var groupComparison = a.group.localeCompare(b.group);
            if (groupComparison !== 0) {
                return groupComparison;
            }
        }
        return a.id.localeCompare(b.id);
    });
    return __spreadArray(__spreadArray([], groupedTags, true), otherTags, true);
}
export function parseTagId(tagId) {
    if (!tagId) {
        return undefined;
    }
    if (tagId.includes(':')) {
        return parseTagIdWithGroup(tagId);
    }
    return {
        id: tagId,
        visibleName: TagNameFromId(tagId, [])
    };
}
function parseTagIdWithGroup(tagId) {
    var parts = tagId.split(':');
    return {
        id: tagId,
        visibleName: TagNameFromId(parts[1], []),
        group: parts[0]
    };
}
